import styled from 'styled-components';
import {mediaQueries} from '../../modules/common';

/**
 * Component that contains the body of the terms, privacy and about pages
 */
const CommonBody = styled.div`
    width: 740px;
    margin: 0 auto 80px;
    padding-bottom: 16px;
    position: relative;

    ${mediaQueries.lessThan('small')`
      width: unset;
      margin: 0 16px;
      position: relative;
    `}
`;

export default CommonBody;
